/**
 * `animate-spin` respects the global `prefers-reduced-motion: reduce`
 * override already declared in index.css (animation-duration forced to
 * 0.01ms), so this component doesn't need its own reduced-motion handling.
 */
export function Spinner({ className = '' }: { className?: string }) {
  return (
    <svg aria-hidden="true" className={`animate-spin ${className}`} viewBox="0 0 24 24" fill="none">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
}

/** Loading state for a form/list section — role="status" + visible text satisfies "todo form/lista tem estado ... carregando" + screen-reader announcement. */
export function LoadingState({ label }: { label: string }) {
  return (
    <div role="status" className="flex items-center gap-3 py-8 text-sm text-muted-foreground">
      <Spinner className="h-5 w-5" />
      <span>{label}</span>
    </div>
  );
}
